module.exports = __webpack_public_path__ + "static/media/sense4010.830b74a0.jpg";